import React from 'react';
import lightBg from '../../Assets/testimonialsBg.png'
import contactBg from '../../Assets/contactBg.png'
import '../../App.css'
import {
     Ripple,
     initTE,
   } from "tw-elements";

const Contact = () => {
     initTE({ Ripple });
     return (
          <div id='#contact' className='  px-3 bg-no-repeat' style={{ backgroundImage: `url(${lightBg})`, height: ' ', }} >
               <div className='bg-no-repeat bg-right-top' style={{ backgroundImage: `url(${contactBg})`, backgroundSize: '25%' }}  >
                    {/* <!-- component --> */}
                    <div class=" flex   justify-center  content md:px-10 lg:px-20  max-w-[1400px]  mx-auto  ">

                         <div class="w-full    ">
                              <div className='text-center mt-6'>
                                   <h1 
                                    data-aos="fade-zoom-in"
                                    data-aos-easing="ease-in-back"
                                    data-aos-delay="300"
                                    data-aos-offset="0"
                                   className='text-[80px] md:text-[130px]  font-extrabold   text-gray-500  text-opacity-20'>CONTACT</h1>
                                   <h3 className='text-[35px] md:text-[40px] relative font-semibold text-white -mt-[88px] md:-mt-32'>Let's Talk</h3>
                                   <div class="flex -mt-2 justify-center">
                                        <div class="w-16 h-1 rounded-full bg-indigo-500 inline-flex"></div>
                                   </div>
                              </div>
                              <div class="pt-24 pb-10   overflow-hidden">
                                   <div class="  md:flex justify-between gap-0 lg:gap-40  items-center  mx-auto    ">
                                        <div

                                             data-aos="fade-up"
                                             data-aos-duration="1000"

                                             class="w-full lg:w-10/12 mx-auto">
                                             <h1 class="text-4xl sm:text-5xl text-gray-200 dark:text-white font-bold tracking-tight">
                                                  Get in touch
                                             </h1>
                                             <p class="text-normal text-lg sm:text-2xl font-medium text-gray-400  mt-2">
                                                  Fill in the form to start a conversation
                                             </p>

                                             <div class=" mt-6 text-gray-100 ">
                                                  <p className='text-gray-400 mb-1 text-xm'>Address:</p>
                                                  <div className='flex items-center'>
                                                       <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8 text-gray-500">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                                       </svg>
                                                       <div class="ml-2 text-md tracking-wide font-semibold w-40">

                                                           Rajshahi,Bangladesh
                                                       </div>
                                                  </div>
                                             </div>

                                             <div class=" mt-6 text-gray-100 ">
                                                  <p className='text-gray-400 mb-1 text-xm'>Phone:</p>
                                                  <div className='flex items-center'>
                                                       <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8 text-gray-400">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                                                       </svg>
                                                       <div class="ml-2 text-md tracking-wide font-semibold w-40">
                                                       +880 1312285525
                                                       </div>

                                                  </div>
                                             </div>

                                             <div class="  mt-6 text-gray-100 ">
                                                  <p className='text-gray-500 mb-1 text-xm'>Email:</p>
                                                  <div className='flex items-center'>
                                                       <svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" viewBox="0 0 24 24" class="w-8 h-8 text-gray-500">
                                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                                                       </svg>
                                                       <div class="ml-2 text-md tracking-wide font-semibold w-40">
                                                       muhammadbappy989@gmail.com
                                                       </div>

                                                  </div>
                                             </div>
                                        </div>

                                        <form data-aos="zoom-in"
                                             data-aos-delay='200'
                                             data-aos-duration='1000'
                                             class="p-3 mt-10 md:mt-0 w-full md:w-12/12 lg:w-11/12  md:p-10 mx-auto bg-gray-500 md:bg-gray-600 bg-opacity-30 md:bg-opacity-25 rounded-md flex flex-col justify-center">
                                             <h3 className='text-2xl md:text-3xl  text-white font-semibold pb-1'>Send Me Message</h3>
                                             <p className='text-lg text-gray-400 mb-4'>Tell me more about your needs</p>
                                             <div class="flex flex-col">
                                                  <label for="name" class="hidden">Full Name</label>
                                                  <input type="name" name="name" id="name" placeholder="Full Name" class="w-full mt-2 py-3 px-3 rounded-lg  text-gray-200 bg-gray-600 bg-opacity-25 font-semibold focus:border-indigo-500 focus:outline-none" />
                                             </div>

                                             <div class="flex flex-col mt-2">
                                                  <label for="email" class="hidden">Email</label>
                                                  <input type="email" name="email" id="email" placeholder="Email" class="w-full mt-2 py-3 px-3 rounded-lg     bg-gray-600 bg-opacity-25 border-gray-400 dark:border-gray-700 text-gray-200 font-semibold focus:border-indigo-500 focus:outline-none" />
                                             </div>

                                             <div class="flex flex-col mt-2">
                                                  <label for="tel" class="hidden">Number</label>
                                                  <textarea type="tel" name="tel" id="tel" placeholder="Write your messsage..." class="w-full mt-2 py-3 px-3 rounded-lg    bg-gray-600 bg-opacity-25  border-gray-400 dark:border-gray-700 text-gray-200 font-semibold focus:border-indigo-900 focus:outline-none" cols="15" rows="4"></textarea>
                                             </div>

                                             <button
                                              data-te-ripple-init
                                              data-te-ripple-color="light"                              
                                             type="submit" class="md:w-32 animate-btn bg-gradient-to-r from-[#4E10FF] to-[#AB17DF] text-white font-bold py-3 px-6 rounded-[4px] mt-3 hover:bg-indigo-500 transition ease-in-out duration-300">
                                               <a href="mailto:muhammadbappy989@gmail.com?cc=sadikulsad0810@gmail.com&subject=Inquiry%20about%20Your%20Products%2FServices&body=Dear%20Saroar%20Jahan%20Bappy%2C%0D%0A%0D%0A" target="_blank ">Submit</a>
                                             </button>
                                        </form>
                                   </div>
                              </div>
                         </div>
                    </div>
               </div>
          </div>
     );
};

export default Contact;